export const _ValidationType = {
	Liveness: 'Liveness',
	Regex: 'Regex',
} as const;
export type _ValidationType = (typeof _ValidationType)[keyof typeof _ValidationType];
/* -------------------------------------------------------------------------------------------------------------- */

export const ValidationSubType = {
	CompareImage: 'CompareImage',
	CompareFieldValue: 'CompareFieldValue',
	CompareWithValue: 'CompareWithValue',
} as const;
export type ValidationSubType = (typeof ValidationSubType)[keyof typeof ValidationSubType];
